'use client';

import { useEffect } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { observer } from 'mobx-react-lite';
import { useAuthStore, useModalStore, useWelcomeVideoStore } from '@/presentation/hooks/useStores';

interface WalletLinkEntryProps {
  ready: boolean;
}

export const WalletLinkEntry = observer(function WalletLinkEntry({ ready }: WalletLinkEntryProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const auth = useAuthStore();
  const modals = useModalStore();
  const welcomeVideo = useWelcomeVideoStore();

  useEffect(() => {
    if (!['/', '/order'].includes(pathname) || searchParams.get('action') !== 'wallet') return;
    const url = new URL(window.location.href);
    if (url.pathname !== pathname || url.searchParams.get('action') !== 'wallet') return;
    welcomeVideo.deferAutomaticForVisit();
    if (!auth.isHydrated || !ready) return;
    if (!auth.isAuthenticated) {
      const destination = `${url.pathname}${url.search}${url.hash}`;
      router.replace(`/sign-in?redirect=${encodeURIComponent(destination)}`);
      return;
    }
    url.searchParams.delete('action');
    // Next copies its internal history state and synchronizes search params when passed null.
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
    modals.openShoppingWalletDrawer();
  }, [auth.isAuthenticated, auth.isHydrated, modals, pathname, ready, router, searchParams, welcomeVideo]);

  return null;
});
